/**
 * Detects the operating system of the current device from the user agent.
 *
 * Ported from the legacy Collins UI (`collins.main.js`) so the Wootric NPS
 * widget reports the same `device-o-s` values as the AngularJS application.
 */
export type DeviceOS = "Windows Phone" | "Android" | "iOS" | "Web" | "Unknown";

export const getDeviceOS = (): DeviceOS => {
  if (typeof navigator === "undefined") {
    return "Unknown";
  }

  const legacyNavigator = navigator as Navigator & { vendor?: string };
  const legacyWindow = window as Window & {
    opera?: string;
    MSStream?: unknown;
  };

  const userAgent =
    navigator.userAgent ?? legacyNavigator.vendor ?? legacyWindow.opera ?? "";

  // Windows Phone must be checked first as its user agent also contains "Android".
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection from http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !legacyWindow.MSStream) {
    return "iOS";
  }

  if (/Windows NT|Macintosh|Linux|CrOS/.test(userAgent)) {
    return "Web";
  }

  return "Unknown";
};
